import i18n from '@/locales'

export const IMAGE_MSG = {
  ubuntu: {
    label: 'Ubuntu',
    position: '0px -91px',
  },
  centos: {
    label: 'Centos',
    position: '0px -128px',
  },
  linux: {
    label: 'Linux',
    position: '0px -18px',
  },
  freebsd: {
    label: 'Freebsd',
    position: '0px -54px',
  },
  debian: {
    label: 'Debian',
    position: '0px -110px',
  },
  coreos: {
    label: 'CorreOS',
    position: '0px -165px',
  },
  gentoo: {
    label: 'Gentoo',
    position: '0px -146px',
  },
  windows: {
    label: 'Windows',
    position: '0px 2px',
  },
  rhel: {
    label: 'RedHat',
    position: '0px -34px',
  },
  redhat: {
    label: 'RedHat',
    position: '0px -34px',
  },
}

export const CUSTOME_IMG = {
  opensuse: {
    label: 'openSUSE',
    url: 'opensuse',
  },
  suse: {
    label: 'SUSE',
    url: 'suse',
  },
  fedora: {
    label: 'Fedora',
    url: 'fedora',
  },
  openeuler: {
    label: 'openEuler',
    url: 'openeuler',
  },
  euleros: {
    label: 'euleros',
    url: 'euleros',
  },
  amazon: {
    label: 'Amazon',
    url: 'amazon',
  },
  aliyun: {
    label: 'Aliyun',
    url: 'aliyun',
  },
  alibaba: {
    label: 'Aliyun',
    url: 'aliyun',
  },
  tencent: {
    label: 'Tencent',
    url: 'tencent',
  },
  kylin: {
    label: 'kylin',
    url: 'kylin',
  },
  nfs: {
    label: i18n.t('compute.os.nfs'),
    url: 'nfs',
  },
  uos: {
    label: 'UOS',
    url: 'uos',
  },
  'uos/server': {
    label: 'UOS',
    url: 'uos',
  },
  android: {
    label: 'Android',
    url: 'android',
  },
  vmware: {
    label: 'VMWare',
    url: 'vmware',
  },
  cirros: {
    label: 'CirrOS',
    url: 'cirros',
  },
  neokylin: {
    label: 'neokylin',
    url: 'neokylin',
  },
  rocky: {
    label: 'Rocky',
    url: 'rocky',
  },
  anolis: {
    label: 'Anolis',
    url: 'anolis',
  },
  opencloudos: {
    label: 'OpenCloudOS',
    url: 'opencloudos',
  },
  almalinux: {
    label: 'AlmaLinux',
    url: 'almalinux',
  },
  openkylin: {
    label: 'OpenKylin',
    url: 'openkylin',
  },
  uosdesktop: {
    label: 'UOSDesktop',
    url: 'uosdesktop',
  },
  tencentos: {
    label: 'TenecnetOS Server',
    url: 'tencentos',
  },
}
